import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useTheme } from '@mui/material/styles';

import { setLanguage } from '@common/Util';

const PrivacyPolicy = () => {
  const [html, setHtml] = useState('');
  const theme = useTheme();

  const language = setLanguage().toLowerCase();

  const link = theme?.footer?.privacyPolicy?.[language || 'en'];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(link);
        const content = await response.text();
        setHtml(content);
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <Container maxWidth='md' sx={{ mt: 4, mb: 4, minHeight: '90vh' }}>
      <Box
        sx={{
          '& h2': {
            marginTop: '1rem',
            marginBottom: '0.5rem'
          },
          '& a': {
            color: theme.palette.primary.contrastText
          }
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </Container>
  );
};
export default PrivacyPolicy;
